import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] border-t border-white/5 mt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-medium mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-gold">Southeast Asia</span>
              <br />
              <span className="text-white text-sm tracking-[0.3em]">LUXURY YACHTS</span>
            </h3>
            <p className="text-white/60 text-sm leading-relaxed">
              Your premier gateway to superyacht excellence across Southeast Asia's most exclusive waters.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-widest text-xs">Explore</h4>
            <div className="flex flex-col gap-2">
              <Link to="/listings" className="text-white/60 hover:text-gold transition-colors text-sm" data-testid="footer-yachts">
                Yacht Listings
              </Link>
              <Link to="/guides" className="text-white/60 hover:text-gold transition-colors text-sm" data-testid="footer-guides">
                Expert Guides
              </Link>
              <Link to="/about" className="text-white/60 hover:text-gold transition-colors text-sm" data-testid="footer-about">
                About Us
              </Link>
              <Link to="/contact" className="text-white/60 hover:text-gold transition-colors text-sm" data-testid="footer-contact">
                Contact
              </Link>
            </div>
          </div>

          {/* Destinations */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-widest text-xs">Destinations</h4>
            <div className="flex flex-col gap-2">
              <span className="text-white/60 text-sm">Andaman Sea, Thailand</span>
              <span className="text-white/60 text-sm">Raja Ampat, Indonesia</span>
              <span className="text-white/60 text-sm">Mergui Archipelago, Myanmar</span>
              <span className="text-white/60 text-sm">Palawan, Philippines</span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-widest text-xs">Contact</h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:info@seluxuryyachts.com" className="text-white/60 hover:text-gold transition-colors text-sm flex items-center gap-2" data-testid="footer-email">
                <Mail size={16} />
                info@seluxuryyachts.com
              </a>
              <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-gold transition-colors text-sm flex items-center gap-2" data-testid="footer-whatsapp">
                <Phone size={16} />
                WhatsApp Inquiry
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 text-center">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Southeast Asia Luxury Yachts. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
